module.exports = __webpack_public_path__ + "img/16t.92254865.jpg";